// extracted by mini-css-extract-plugin
export default {"page":"TermsOfService_page__-wsy9","frame":"TermsOfService_frame__ziGSD"};